const routes = [
    {
        path: "/esl/attendance/:sessionId",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "eslattendance_getattendanceswithsessionandweek"
        }
    }
]

export default routes;

